/* Dark World: keep selected bundle variants through tier changes and show their gallery. */
(function () {
  'use strict';
  var config = document.getElementById('dark-world-config');
  if (!config || window.__darkWorldSelection) return;
  window.__darkWorldSelection = true;
  var data = JSON.parse(config.textContent), mediaByVariant = {};
  data.variants.forEach(function (v) { mediaByVariant[String(v.id)] = String(v.media); });
  function showSelection(bundle, slotIndex) {
    var slot = bundle.state && bundle.state.slots[slotIndex];
    var v = slot && bundle.resolve(slot), media = v && mediaByVariant[String(v.i)];
    if (v) {
      var price = document.querySelector('.rv-price__now');
      var compare = document.querySelector('.rv-price__was');
      var save = document.querySelector('.rv-price .rv-save');
      if (price) price.textContent = '$' + (v.p / 100).toFixed(2);
      if (compare) { compare.textContent = '$' + (v.c / 100).toFixed(2); compare.hidden = v.c <= v.p; }
      if (save) {
        save.hidden = v.c <= v.p;
        Array.from(save.childNodes).filter(function (n) { return n.nodeType === 3; }).forEach(function (n) {
          n.textContent = 'SAVE ' + Math.floor((v.c - v.p) * 100 / v.c) + '%';
        });
      }
    }
    var gallery = document.querySelector('media-gallery');
    if (!gallery || !media || media === '0') return;
    var slide = gallery.querySelector('.product__media-item[data-media-id$="-' + media + '"]');
    if (!slide) return;
    if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(slide.dataset.mediaId, false);
    else {
      var thumb = gallery.querySelector('[data-target="' + slide.dataset.mediaId + '"] button');
      if (thumb) thumb.click();
    }
  }
  function init() {
    document.querySelectorAll('fish-bundle').forEach(function (bundle) {
      var vm = document.getElementById('fish-vm-' + bundle.dataset.sectionId);
      if (!vm || JSON.parse(vm.textContent).productId !== data.productId || bundle.__darkWorldBound) return;
      // Match the chooser to the current gallery, using one front preview per style.
      var gallery = document.querySelector('media-gallery');
      var galleryOrder = gallery ? Array.from(gallery.querySelectorAll('.product__media-item')).map(function (slide) {
        return slide.dataset.mediaId.split('-').pop();
      }) : [];
      var frontByStyle = {};
      bundle.variants.forEach(function (v) {
        var media = mediaByVariant[String(v.i)];
        if (!frontByStyle[v.o1] && media && media !== '0') frontByStyle[v.o1] = media;
      });
      if (galleryOrder.length) {
        bundle.o1Values = bundle.o1Values.slice().sort(function (a, b) {
          var ai = galleryOrder.indexOf(frontByStyle[a]), bi = galleryOrder.indexOf(frontByStyle[b]);
          return (ai < 0 ? galleryOrder.length : ai) - (bi < 0 ? galleryOrder.length : bi);
        });
        var nativeImgFor = bundle.imgFor;
        bundle.imgFor = function (style) {
          var media = frontByStyle[style];
          var slide = media && gallery.querySelector('.product__media-item[data-media-id$="-' + media + '"]');
          var image = slide && slide.querySelector('img');
          return image ? image.src : nativeImgFor.call(this, style);
        };
        bundle.renderSlots(bundle.querySelector('.fish-tier.is-selected [data-slots]'));
        bundle.update();
      }
      var selectTier = bundle.selectTier;
      bundle.selectTier = function (index) {
        var previous = this.state ? this.state.slots.map(function (s) { return Object.assign({}, s); }) : [];
        var remembered = this.tierPicks && this.tierPicks[index];
        selectTier.call(this, index);
        // An unopened tier starts with the shopper's picks, not the first catalog style.
        if (previous.length) {
          this.state.slots = this.state.slots.map(function (fallback, i) {
            var source = i === 0 ? previous[0] : (remembered ? fallback : (previous[i] || previous[0]));
            var pick = Object.assign({}, source);
            var variant = bundle.resolve(pick);
            return variant && variant.a ? pick : fallback;
          });
          this.renderSlots(this.tiers[index].querySelector('[data-slots]'));
          this.update();
        }
        showSelection(this, 0);
      };
      // Honor a directly linked Shopify variant, including its selected size.
      var variantId = new URLSearchParams(window.location.search).get('variant');
      var selected = variantId && bundle.variants.find(function (v) { return String(v.i) === variantId && v.a; });
      if (selected) {
        bundle.state.slots[0] = { o1: selected.o1, o2: selected.o2, o3: selected.o3 };
        bundle.update();
        showSelection(bundle, 0);
      }
      bundle.addEventListener('click', function (event) {
        var pill = event.target.closest('.fish-pill');
        if (pill && !pill.disabled) showSelection(bundle, Number(pill.dataset.slot));
      });
      // submit()/addViaAjax() already resolve each exact slot to its native variant ID.
      showSelection(bundle, 0);
      bundle.__darkWorldBound = true;
    });
  }
  function ready() { customElements.whenDefined('fish-bundle').then(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
